export default __webpack_public_path__ + "static/media/conflictfree-reversed.45d4a0be.svg";